import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#00afcb',
		},
	},
	typography: {
		button: {
			textTransform: 'capitalize',
			borderRadius: '6px',
			'&.MuiButton-containedPrimary': {
				color: 'white',
			},
		},
	},
});

export default theme;
